import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import { Box, Link, Text, Label } from '@primer/react';
import * as React from 'react';
export default {
  HeroLayout,
  Box,
  Link,
  Text,
  Label,
  React
};